import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import {ITraconLocid,ITraconModelResponse, ITraconModelRequest,ITraconModelSummaryResponse} from './tracon-model';
import { HttpHelper } from '../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class TraconModelService {

    private _genericUrl = `api/data/`;
    private _traconReportUrl=`api/systemmanagement`; 

    constructor(private _httpHelper: HttpHelper) { }

    public getTraconList(): Observable<ITraconLocid> {
         return this._httpHelper.get(`${this._genericUrl}/tracon`);
    }
    public getYearsList(): Observable<ITraconLocid> {
         return this._httpHelper.get(`${this._genericUrl}/years`)
    }
    public getTraconResult(traconRequest: ITraconModelRequest):Observable<ITraconModelResponse> {
         return this._httpHelper.post(`${this._traconReportUrl}/GetTraconResult`, traconRequest)
    }
    public getTraconSummaryResult(traconRequest: ITraconModelRequest):Observable<ITraconModelSummaryResponse> {
         return this._httpHelper.post(`${this._traconReportUrl}/GetTraconSummaryResult`, traconRequest)
    }
    public reforecastAopsIfr(traconRequest: ITraconModelRequest):Observable<ITraconModelResponse> {
         return this._httpHelper.post(`${this._traconReportUrl}/ReforecastAopsIfr`, traconRequest)
    }
    public reforecastTracon(traconRequest: ITraconModelRequest):Observable<ITraconModelResponse> {
         return this._httpHelper.post(`${this._traconReportUrl}/ReforecastTracon`, traconRequest)
    }
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tracon-models/tracon-model.service.ts
 **/